import { calculationLimits, designVehicles } from "store/calculation.config";
import { calculateSpeedAlongVerticalProfile } from "utilities/genericRoadUtilities/calculateSpeedAlongVerticalProfile";
import { parseVerticalPoints } from "utilities/geometricRoadutilities/parseVerticalPoints";
//import { mergeVerticalAndSpeedData } from "utilities/geometricRoadutilities/mergeVerticalAndSpeedData";

export const calculateOvertaking = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_INITIAL_SPEED_TOO_LOW: false,
        TOOLS_INITIAL_SPEED_TOO_HIGH: false,
        TOOLS_AADT_TOO_LOW: false,
        TOOLS_AADT_HEAVY_TOO_LOW: false,
        TOOLS_AADT_HEAVY_TOO_HIGH: false,
        TOOLS_OVERTAKING_INITIAL_SPEED_ABOVE_SPEEDLIMIT: false,
        TOOLS_OVERTAKING_LANE_NOT_NECESSARY_FOR_AADT: false,
    };

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            verticalGeometry: {value: null, valid: null, severity: null},
            verticalPoints: {value: null, valid: null, severity: null},
            speedlimit: {value: null, valid: null, severity: null},
            initialSpeed: {value: null, valid: null, severity: null},
            aadt: {value: null, valid: null, severity: null},
            aadtHeavy: {value: null, valid: null, severity: null},
        },
        derived:
        {
            speedPassive: {value: null, valid: null, severity: null},
            speedActive: {value: null, valid: null, severity: null},
            speedOncoming: {value: null, valid: null, severity: null},
            criticalSpeedStart: {value: null, valid: null, severity: null},
            criticalSpeedEnd: {value: null, valid: null, severity: null},
            
        },
        output:
        {
            overtakingLength: {value: null, valid: null, severity: null},
            overtakingData: {value: null, valid: null, severity: null},
            overtakingIntervalsForward: {value: [], valid: null, severity: null},
            overtakingIntervalsBackward: {value: [], valid: null, severity: null},
            maxSpeed: {value: null, valid: null, severity: null},
            minSpeed: {value: null, valid: null, severity: null},
            minElevation: {value: null, valid: null, severity: null},
            maxElevation: {value: null, valid: null, severity: null},
            minStationing: {value: null, valid: null, severity: null},
            maxStationing: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    validateRelations(calculationContext, errors);
    calculateDerived(calculationContext, errors);
    calulcateOutput(calculationContext, errors);
    
    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return (calculationContext);
}

const validateValues = (ctx, errors) => {
    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region initial speed
    if(ctx.normalizedInput.initialSpeed.trim() !== '')
    {
        const initialSpeed = Number(ctx.normalizedInput.initialSpeed.trim());
        if(initialSpeed < calculationLimits.minSpeed)
        {
            ctx.input.initialSpeed = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_INITIAL_SPEED_TOO_LOW = true;
        }
        else if(initialSpeed > calculationLimits.maxSpeed)
        {
            ctx.input.initialSpeed = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_INITIAL_SPEED_TOO_HIGH = true;
        }
        else
        {
            ctx.input.initialSpeed = {value: initialSpeed, valid: true, severity: null};
        }
    }
    // #endregion

    // #region aadt
    if(ctx.normalizedInput.aadt.trim() !== '')
    {
        const aadt = Number(ctx.normalizedInput.aadt.trim());
        if(aadt <= 0)
        {
            ctx.input.aadt = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_TOO_LOW = true;
        }
        else
        {
            ctx.input.aadt = {value: aadt, valid: true, severity: null};
        }
    }
    // #endregion

    // #region aadt heavy
    if(ctx.normalizedInput.aadtHeavy.trim() !== '')
    {
        const aadtHeavy = Number(ctx.normalizedInput.aadtHeavy.trim());
        if(aadtHeavy < 0)
        {
            ctx.input.aadtHeavy = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_HEAVY_TOO_LOW = true;
        }
        else if(aadtHeavy > 100)
        {
            ctx.input.aadtHeavy = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_HEAVY_TOO_HIGH = true;
        }
        else
        {
            ctx.input.aadtHeavy = {value: aadtHeavy, valid: true, severity: null};
        }
    }
    // #endregion

    // #region vertical geometry
    if(ctx.normalizedInput.verticalGeometry)
    {
        if(Array.isArray(ctx.normalizedInput.verticalGeometry) && ctx.normalizedInput.verticalGeometry.length !== 0)
        {
            ctx.input.verticalGeometry = {
                value: ctx.normalizedInput.verticalGeometry,
                valid: true,
                severity: false,
            }

            ctx.input.verticalPoints = {
                value: parseVerticalPoints(ctx.normalizedInput.verticalGeometry),
                valid: true,
                severity: false,
            }
        }
    }
    // #endregion
}

const validateRelations = (ctx, errors) => {
    if(ctx.input.speedlimit.valid && ctx.input.initialSpeed.valid)
    {
        if(ctx.input.speedlimit.value < ctx.input.initialSpeed.value)
        {
            errors.TOOLS_OVERTAKING_INITIAL_SPEED_ABOVE_SPEEDLIMIT = true;
            ctx.input.initialSpeed = {
                value: null,
                valid: false,
                severity: 'error'
            }
        }
    }
}

const calculateDerived = (ctx, errors) => {
    if(ctx.input.speedlimit.valid)
    {
        ctx.derived.speedPassive = {
            value: ctx.input.speedlimit.value - 5,
            valid: true,
            severity: null
        }

        ctx.derived.speedActive = {
            value: 1.19 * ctx.input.speedlimit.value + 3.87,
            valid: true,
            severity: null
        }

        ctx.derived.speedOncoming = {
            value: ctx.input.speedlimit.value + 5,
            valid: true,
            severity: null
        }
    }

    if(ctx.input.speedlimit.valid && ctx.input.aadt.valid && ctx.input.aadtHeavy.valid)
    {
        if(ctx.input.aadt.value < 4000) errors.TOOLS_OVERTAKING_LANE_NOT_NECESSARY_FOR_AADT = true;

        if(ctx.input.aadt.value * ctx.input.aadtHeavy.value * 0.01 >= 400)
        {    
            ctx.derived.criticalSpeedStart = {
                value: Math.max(ctx.input.speedlimit.value - 15, 30),
                valid: true,
                severity: null
            }

            ctx.derived.criticalSpeedEnd = {
                value: Math.max(ctx.input.speedlimit.value - 10, 30),
                valid: true,
                severity: null
            }
        }
        else
        {
            ctx.derived.criticalSpeedStart = {
                value: Math.max(ctx.input.speedlimit.value - 20, 30),
                valid: true,
                severity: null
            }

            ctx.derived.criticalSpeedEnd = {
                value: Math.max(ctx.input.speedlimit.value - 15, 30),
                valid: true,
                severity: null
            }
        }
    }
}

const calulcateOutput = (ctx, errors) => {

    // #region calculating min and max elevation and stationing
    if(ctx.input.verticalGeometry.valid)
    {
        ctx.output.minStationing = {
            value: ctx.input.verticalGeometry.value[0].startStationing,
            valid: true,
            severity: null
        }

        ctx.output.maxStationing = {
            value: ctx.input.verticalGeometry.value[ctx.input.verticalGeometry.value.length-1].endStationing,
            valid: true,
            severity: null
        }
    }

    if(ctx.input.verticalPoints.valid)
    {
        ctx.output.minElevation = {
            value: Math.min(...ctx.input.verticalPoints.value.map(c => c.elevation)),
            valid: true,
            severity: null
        }

         ctx.output.maxElevation = {
            value: Math.max(...ctx.input.verticalPoints.value.map(c => c.elevation)),
            valid: true,
            severity: null
        }
    }
    // #endregion

    // #region calculating overtaking length
    if(ctx.input.speedlimit.valid)
    {
        ctx.output.overtakingLength = {
            value: (7.022 * ctx.input.speedlimit.value**2 + 145.899 * ctx.input.speedlimit.value + 182.049)/(1.19 * ctx.input.speedlimit.value - 2.08),
            valid: true,
            severity: false,
        }
    }
    // #endregion

    // #region calculating overtaking intervals and speed graph
    if(ctx.input.speedlimit.valid && ctx.input.aadt.valid && ctx.input.aadtHeavy.valid && ctx.input.verticalGeometry.valid)
    {
        const overtakingSpeedData = calculateSpeedAlongVerticalProfile({
            verticalGeometry: ctx.input.verticalGeometry.value,
            vehicle: designVehicles.vogntog,
            speedlimit: ctx.input.speedlimit.value,
            initialSpeed: ctx.input.initialSpeed.value
        });

        let min = Infinity;
        let max = -Infinity;

        for(const p of overtakingSpeedData.forward)
        {
            if (p.speed < min) min = p.speed;
            if (p.speed > max) max = p.speed;
        }

        for(const p of overtakingSpeedData.backward)
        {
            if (p.speed < min) min = p.speed;
            if (p.speed > max) max = p.speed;
        }

        ctx.output.minSpeed = {
            value: min,
            valid: true,
            severity: null
        }

        ctx.output.maxSpeed = {
            value: max,
            valid: true,
            severity: null
        }

        // #region calculating overtaking intervals
        const firstStationing = ctx.input.verticalGeometry.value[0].startStationing;
        const lastStationing = ctx.input.verticalGeometry.value[ctx.input.verticalGeometry.value.length-1].endStationing;

        if(overtakingSpeedData.forward[0].stationing < firstStationing)
        {
            overtakingSpeedData.forward[0].stationing = firstStationing;
        }

        if(overtakingSpeedData.forward[overtakingSpeedData.forward.length-1].stationing < lastStationing)
        {
            overtakingSpeedData.forward[overtakingSpeedData.forward.length-1].stationing = lastStationing;
        }

        if(overtakingSpeedData.backward[0].stationing > lastStationing)
        {
            overtakingSpeedData.backward[0].stationing = lastStationing
        }

        if(overtakingSpeedData.backward[overtakingSpeedData.backward.length-1].stationing < firstStationing)
        {
            overtakingSpeedData.backward[overtakingSpeedData.backward.length-1].stationing = firstStationing;
        }

        // #region overtaking lane forward

        let currentObjectForward = { overtakingLane: false, data: [] };

        if(overtakingSpeedData.forward[0].speed < ctx.derived.criticalSpeedStart.value)
        {
            currentObjectForward.overtakingLane = true;
        }

        for(let i = 0; i<overtakingSpeedData.forward.length; i++)
        {
            let obj = {
                speed: overtakingSpeedData.forward[i].speed,
                stationing: overtakingSpeedData.forward[i].stationing
            };
            currentObjectForward.data.push(obj);

            if(i === overtakingSpeedData.forward.length-1)
            {
                ctx.output.overtakingIntervalsForward.value.push(currentObjectForward);
                break;
            }

            if(overtakingSpeedData.forward[i].speed > ctx.derived.criticalSpeedStart.value &&
                overtakingSpeedData.forward[i+1].speed < ctx.derived.criticalSpeedStart.value &&
                currentObjectForward.overtakingLane === false)
            {
                ctx.output.overtakingIntervalsForward.value.push(currentObjectForward);
                currentObjectForward = { overtakingLane: true, data: [] };
            }
            else if(overtakingSpeedData.forward[i].speed < ctx.derived.criticalSpeedEnd.value &&
                overtakingSpeedData.forward[i+1].speed > ctx.derived.criticalSpeedEnd.value &&
                currentObjectForward.overtakingLane === true)
            {
                ctx.output.overtakingIntervalsForward.value.push(currentObjectForward);
                currentObjectForward = { overtakingLane: false, data: [] };
            }
        }

        ctx.output.overtakingIntervalsForward.valid = true;

        // #endregion

        // #region overtaking lane backward

        let currentObjectBackward = { overtakingLane: false, data: [] };

        if(overtakingSpeedData.backward[0].speed < ctx.derived.criticalSpeedStart.value)
        {
            currentObjectBackward.overtakingLane = true;
        }

        for(let i = 0; i<overtakingSpeedData.backward.length; i++)
        {
            let obj = {
                speed: overtakingSpeedData.backward[i].speed,
                stationing: overtakingSpeedData.backward[i].stationing
            };
            currentObjectBackward.data.push(obj);

            if(i === overtakingSpeedData.backward.length-1)
            {
                ctx.output.overtakingIntervalsBackward.value.push(currentObjectBackward);
                break;
            }

            if(overtakingSpeedData.backward[i].speed > ctx.derived.criticalSpeedStart.value &&
                overtakingSpeedData.backward[i+1].speed < ctx.derived.criticalSpeedStart.value &&
                currentObjectBackward.overtakingLane === false)
            {
                ctx.output.overtakingIntervalsBackward.value.push(currentObjectBackward);
                currentObjectBackward = { overtakingLane: true, data: [] };
            }
            else if(overtakingSpeedData.backward[i].speed < ctx.derived.criticalSpeedEnd.value &&
                overtakingSpeedData.backward[i+1].speed > ctx.derived.criticalSpeedEnd.value &&
                currentObjectBackward.overtakingLane === true)
            {
                ctx.output.overtakingIntervalsBackward.value.push(currentObjectBackward);
                currentObjectBackward = { overtakingLane: false, data: [] };
            }
        }

        ctx.output.overtakingIntervalsBackward.valid = true;

        // #endregion


    
        // #endregion
    }
    // #endregion
}
